module.exports = __webpack_public_path__ + "static/media/1756_2020Gallery.6983c765.JPEG";